// constants
import { ChatSubmissionsActionTypes } from './constants';

const INIT_STATE = {
    chatSubmissions: [],
    jobTitle: {},
    page: 1,
    limit: 10,
    totalPages: 0,
    totalResults: 0,
    loading: false,
    hasErrors: false,
    submitted: false,
    isDeleted: false,
};

interface ChatSubmissionsActionType {
    type:
    | ChatSubmissionsActionTypes.API_RESPONSE_SUCCESS
    | ChatSubmissionsActionTypes.API_RESPONSE_ERROR
    | ChatSubmissionsActionTypes.CHAT_SUBMISSIONS_LIST

    payload: {
        actionType?: string;
        responseData?: any;
        error?: any;
        validationError?: { error: string; key: string; }[];
        hasErrors: boolean,
        submitted: boolean,
        isDeleted: boolean,
    };
}

interface State {
    chatSubmissions: any;
    jobTitle: any;
    page: number;
    limit: number;
    totalPages: number;
    totalResults: number;
}

const ChatSubmissions = (state: State = INIT_STATE, action: ChatSubmissionsActionType): any => {
    switch (action.type) {
        case ChatSubmissionsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload?.actionType) {
                case ChatSubmissionsActionTypes.CHAT_SUBMISSIONS_LIST: {
                    return {
                        ...state,
                        chatSubmissions: action.payload?.responseData?.data,
                        page: action.payload?.responseData?.page,
                        limit: action.payload?.responseData?.limit,
                        totalPages: action.payload?.responseData?.totalPages,
                        totalResults: action.payload?.responseData?.totalResults,
                        loading: true,
                        submitted: false,
                    };
                }

                default:
                    return { ...state };
            }

        case ChatSubmissionsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload?.actionType) {
                case ChatSubmissionsActionTypes.CHAT_SUBMISSIONS_LIST: {
                    return {
                        ...state,
                        error: action.payload.error,
                        hasErrors: true,
                        loading: true,
                        submitted: false,
                    };
                }

                default:
                    return { ...state };
            }
        default:
            return { ...state };
    }
};

export default ChatSubmissions;
